import React from "react";

const SiteFooter = () => (
  <footer className="py-16 px-6" style={{ backgroundColor: "#0B1628" }}>
    <div className="max-w-4xl mx-auto text-center">
      <p className="text-sm text-white/40 mb-8">
        © {new Date().getFullYear()} AdrisDavis.com
      </p>
      <p className="text-xs text-white/25">
        A Prestigious Companies Network | Strategic Partner of the Prestigious Travel Club Foundation
      </p>
    </div>
  </footer>
);

export default SiteFooter;
